
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class SortingGrid extends Serenity.EntityGrid<SortingRow, any> {
        protected getColumnsKey() { return 'Inventory.Sorting'; }
        protected getDialogType() { return SortingDialog; }
        protected getIdProperty() { return SortingRow.idProperty; }
        protected getInsertPermission() { return SortingRow.insertPermission; }
        protected getLocalTextPrefix() { return SortingRow.localTextPrefix; }
        protected getService() { return SortingService.baseUrl; }
        private rowSelection: Serenity.GridRowSelectionMixin;
        private autoSize;
        constructor(container: JQuery) {
            super(container);
        }
        protected addButtonClick() {

            let now = new Date();
            var voucherNo = FormatHelper.GetVoucherNo(73);
            var userDefinition = Q.Authorization.userDefinition;
            var autoposting = OMS.VoucherMasterRow.getLookup().itemById[73].AutoPosting;

            this.editItem(<SortingRow>{
                VoucherNo: voucherNo,
                TransDate: now.toDateString(),
                Line_No: 0,
                CompanyId: userDefinition.CompanyId,
                FinancialYearId: userDefinition.FinancialYearId,
                UserId: userDefinition.UserId,
                CurrencyId: userDefinition.CurrencyId,
                VoucherTypeId: 73,
                AutoPosting: autoposting

            });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}